import { render, staticRenderFns } from "./bankCardList.vue?vue&type=template&id=63f7792a&scoped=true"
import script from "./bankCardList.vue?vue&type=script&lang=js"
export * from "./bankCardList.vue?vue&type=script&lang=js"
import style0 from "./bankCardList.vue?vue&type=style&index=0&id=63f7792a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f7792a",
  null
  
)

export default component.exports